/**
 * DTO-level status of a firm membership or invitation, spanning two tables.
 *
 * `PENDING` — an open row in `firm_invitations` (not yet accepted or revoked).
 * `ACTIVE` / `REVOKED` — the actual state of a `firm_user_roles` row.
 */
export enum FirmUserRoleStatus {
  /** An open, not-yet-resolved row in `firm_invitations` — never stored as a `firm_user_roles.status` value. */
  PENDING = 'pending',
  /** Assignment is live and resolved by `attachPermissions`. */
  ACTIVE = 'active',
  /** Member removed from the firm; row retained for history. */
  REVOKED = 'revoked'
}

/** The subset of {@link FirmUserRoleStatus} a `firm_user_roles` row can actually hold. */
export type FirmMembershipStatus = FirmUserRoleStatus.ACTIVE | FirmUserRoleStatus.REVOKED;
